import { render } from "./SemillerosComponent.vue?vue&type=template&id=25d75cd4&scoped=true"
import script from "./SemillerosComponent.vue?vue&type=script&lang=js"
export * from "./SemillerosComponent.vue?vue&type=script&lang=js"

import "./SemillerosComponent.vue?vue&type=style&index=0&id=25d75cd4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d75cd4"]])

export default __exports__